/**
 * Exporta a XLSX el Reporte de Estudiantes por Carrera.
 *
 * @param {Object} params
 * @param {Array}  params.resultados  - Filas: { numero, matricula, nombre, genero, tetra_en_curso, turno }
 * @param {Object} params.contexto    - { ciclo, campus, seccion, programa }
 */
import * as XLSX from 'xlsx';
import { getTurnoLabel } from '../constants/turnos';

const COLUMNAS = [
  '#',
  'Matrícula',
  'Nombre',
  'Género',
  'Tetra en curso',
  'Turno',
];

function fechaArchivo() {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}_${pad(d.getHours())}${pad(d.getMinutes())}`;
}

export function exportReporteEstudiantesCarreraXLS({ resultados = [], contexto = {} } = {}) {
  const {
    ciclo = 'Todos',
    campus = 'Todos',
    seccion = 'Todas',
    programa = '—',
  } = contexto;

  const aoa = [
    ['REPORTE ESTUDIANTES POR CARRERA'],
    [`Ciclo Escolar: ${ciclo}`],
    [`Programa: ${programa}`],
    [`Campus: ${campus}`],
    [`Sección: ${seccion}`],
    [`Generado: ${new Date().toLocaleString('es-MX')}`],
    [],
    COLUMNAS,
  ];

  resultados.forEach((r, idx) => {
    aoa.push([
      r.numero ?? (idx + 1),
      r.matricula || '',
      r.nombre || '',
      r.genero || '',
      r.tetra_en_curso ?? '',
      (typeof getTurnoLabel === 'function' ? getTurnoLabel(r.turno) : (r.turno || '')) || '',
    ]);
  });

  const ws = XLSX.utils.aoa_to_sheet(aoa);

  ws['!cols'] = [
    { wch: 6 },
    { wch: 16 },
    { wch: 40 },
    { wch: 12 },
    { wch: 16 },
    { wch: 14 },
  ];

  ws['!merges'] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: 5 } },
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Estudiantes');

  const fileName = `reporte_estudiantes_carrera_${fechaArchivo()}.xlsx`;
  XLSX.writeFile(wb, fileName);
}

export default exportReporteEstudiantesCarreraXLS;
